import App from "@src/App";
import { createRoot } from "react-dom/client";

import "@styles/global.scss";

const root = createRoot(document.getElementById("root")!);
root.render(<App />);
